import {AppStoreProps, ImmerStateCreator} from "./appStore";
import {getLabelConfig} from "../Utils";

export interface GlobalSliceProps {
  labelType: string | null;
  setLabelType: (name: string) => void;
}

export const createGlobalSlice: ImmerStateCreator<AppStoreProps, GlobalSliceProps> = (set, get) => {
  const labelType = null;

  const setLabelType = (name: string) => {
    if (!name) {
      set((state) => {
        state.labelType = null;
        state.printOptions = null;
        state.labels = [];
      });

      return;
    }

    const labelConfig = getLabelConfig(name);

    if (labelConfig) {
      const defaultPrintOptions = labelConfig.getDefaultPrintOptions();

      set((state) => {
        state.labelType = name;
      });

      get().setPrintOptions(defaultPrintOptions);
      get().addLabel(labelConfig.getDefaultLabel(
        defaultPrintOptions.size,
        defaultPrintOptions.orientation,
      ));
    }
  };

  return {
    labelType,
    setLabelType
  };
};
